module.exports = __webpack_public_path__ + "media/Dirge of the Past.b3076856.mp3";